import React from 'react'

import { Box, Link, SectionContainer, Text } from '@vividseats/vivid-ui-kit'

import styles from './styles.module.scss'

export const LEARN_MORE_URL_STRING =
    'https://support.vividseats.com/support/solutions/articles/11000106875-vivid-seats-rewards'

const RewardQuestion: React.FC = () => {
    return (
        <SectionContainer className={styles.section}>
            <Box>
                <Text as="h2" className={styles.title} altFont={true}>
                    Have questions?
                </Text>
                <Text as="p" className={styles.subtitle} altFont={true}>
                    We have answers.
                </Text>
                <Link className={styles.button} href={LEARN_MORE_URL_STRING} isExternal>
                    Learn more
                </Link>
            </Box>
        </SectionContainer>
    )
}

export default RewardQuestion
